"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var Button_1 = require("@material-ui/core/Button");
var buttonWithIconStyles_1 = require("./buttonWithIconStyles");
var ButtonWithIcon = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, _d = _a.iconSize, iconSize = _d === void 0 ? 30 : _d, iconClasses = _a.iconClasses, labelClasses = _a.labelClasses, props = __rest(_a, ["className", "children", "iconSize", "iconClasses", "labelClasses"]);
    var styles = buttonWithIconStyles_1.default(__assign(__assign({}, props), { iconSize: iconSize }));
    return (<Button_1.default {...props} className={[styles.root, className].join(' ')} variant={'contained'} classes={{
        label: (labelClasses !== null && labelClasses !== void 0 ? labelClasses : ''),
    }}>
      {children}
      {iconClasses && <span className={clsx_1.default([styles.icon, iconClasses, (_b = {}, _b[styles.disabledIcon] = props.disabled, _b)])}/>}
    </Button_1.default>);
};
exports.default = ButtonWithIcon;
